export default __webpack_public_path__ + "static/media/pin_unavailable.97e832c3.svg";